import BaseAPI from "../base";

function getTemplates(cafe_id) {
  return BaseAPI.get(`checklists/templates/list/${cafe_id}`);
}

function getTemplate(id) {
  return BaseAPI.get(`checklists/templates/${id}`);
}

function createTemplate(cafe_id) {
  return BaseAPI.post(`checklists/templates/create/${cafe_id}`);
}

function saveTemplate(template_id, data) {
  return BaseAPI.post(`checklists/templates/save/${template_id}`, data);
}

function publishTemplate(template_id) {
  return BaseAPI.post(`checklists/templates/publish/${template_id}`);
}

function unpublishTemplate(template_id) {
  return BaseAPI.post(`checklists/templates/unpublish/${template_id}`);
}

function deleteTemplate(template_id) {
  return BaseAPI.post(`checklists/templates/remove/${template_id}`);
}

function copyTemplate(template_id) {
  return BaseAPI.post(`checklists/templates/copy/${template_id}`);
}

function findArchiveForms(cafe_id, start_date, end_date) {
  return BaseAPI.get(`checklists/forms/archive/${cafe_id}`, {
    start: start_date,
    end: end_date
  });
}

function getArchiveForm(form_id) {
  return BaseAPI.get(`checklists/forms/${form_id}`);
}

export default {
  createTemplate,
  getTemplates,
  getTemplate,
  saveTemplate,
  publishTemplate,
  unpublishTemplate,
  copyTemplate,
  deleteTemplate,
  findArchiveForms,
  getArchiveForm,
};
